if (!customElements.get('product-info')) {
  customElements.define('product-info', class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.quantity__input');
      this.currentVariant = this.querySelector('.product-variant-id');
      this.variantSelects = this.querySelector('variant-radios')
      this.submitButton = this.querySelector('[type="submit"]');
    }

    cartUpdateUnsubscriber = undefined;
    variantChangeUnsubscriber = undefined;

    connectedCallback() {
      if (!this.input) return;
      this.quantityForm = this.querySelector('.product-form__quantity');
      if (!this.quantityForm) return;
      this.setQuantityBoundries();
      if (!this.dataset.originalSection) {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
      }
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        if (event.data.sectionId !== sectionId) return;
        this.updateQuantityRules(event.data.sectionId, event.data.html);
        this.setQuantityBoundries();
      });
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
    }

    setQuantityBoundries() {
      const data = {
        cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
        min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
        max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
        step: this.input.step ? parseInt(this.input.step) : 1
      }

      let min = data.min;
      const max = data.max === null ? data.max : data.max - data.cartQuantity;
      if (max !== null) min = Math.min(min, max);
      if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

      this.input.min = min;
      this.input.max = max;
      this.input.value = min;
      publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
    }

    fetchQuantityRules() {
      if (!this.currentVariant || !this.currentVariant.value) return;
      this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
      fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`).then((response) => {
        return response.text()
      })
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          this.updateQuantityRules(this.dataset.section, html);
          this.setQuantityBoundries();
        })
        .catch(e => {
          console.error(e);
        })
        .finally(() => {
          this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
        });
    }

    updateQuantityRules(sectionId, html) {
      const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
      if (!quantityFormUpdated) return; // Exit if the updated form doesn't exist
      
      if (!this.quantityForm) return; // Exit if the current form doesn't exist
      
      const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
      for (let selector of selectors) {
        const current = this.quantityForm.querySelector(selector);
        const updated = quantityFormUpdated.querySelector(selector);
        if (!current || !updated) continue;
        if (selector === '.quantity__input') {
          const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
          for (let attribute of attributes) {
            const valueUpdated = updated.getAttribute(attribute);
            if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
          }
        } else {
          current.innerHTML = updated.innerHTML;
        }
      }
    }
  }
  )
};

class ProductImageCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const id = this.dataset.selector;

    var swiperThumb = new Swiper("#swiper-thumb-" + id, {
      loop: false,
      slidesPerView: 3,
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      spaceBetween: 10,
      direction: "vertical"
    });

    let config = {
      loop: false,
      slidesPerView: 1,
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      spaceBetween: 10,
      direction: "vertical",
      mousewheel: {
        releaseOnEdges: true,
      },
      direction: "vertical",
      navigation: {
        nextEl: ".swiper-arrow-" + id + "__next",
        prevEl: ".swiper-arrow-" + id + "__prev",
      },
      thumbs: {
        swiper: swiperThumb,
      }
    };

    const swiper = new Swiper("#swiper-" + id, config);

    swiper.on('slideChangeTransitionStart', function () {
      let videoSelector = document.querySelector('.block-product__ugc')?.querySelector('.swiper-slide-active video-player');
      if (videoSelector?.getAttribute('loaded') == 'true') {
        videoSelector.querySelector('video').play();
      } else {
        const activeSlide = document.querySelector('.block-product__ugc')?.querySelector('.swiper-slide-active video-player button');
        if (activeSlide) {
          activeSlide.click();
        }
      }
    });

    swiper.on('slideChangeTransitionEnd', function () {
      const allVideos = document.querySelector('.block-product__ugc').querySelectorAll('.swiper-slide video');
      allVideos.forEach((video) => {
        if (!video.closest('.swiper-slide').classList.contains('swiper-slide-active')) {
          video.pause();
          video.currentTime = 0;
        }
      });
    });

    let videoSelector = '';
    const productVideo = this.querySelectorAll('.video-section__media')
    productVideo.forEach((video) => {
      video.addEventListener('click', function () {
        document.body.classList.add('product-modal__open');
        document.querySelector('.block-product__ugc').classList.toggle('hidden');

        swiper.slideTo(video.dataset.index);
        let activeSlide = swiper.slides[swiper.activeIndex];
        if( activeSlide ){
          videoSelector = activeSlide.querySelector('video-player');
        }else{
          videoSelector = document.querySelector('.block-product__ugc')?.querySelector('.block-first__slide video-player');
        }

        if (videoSelector?.getAttribute('loaded') == 'true') {
          videoSelector.querySelector('video').play();
        } else {
          const activeSlide = videoSelector?.querySelector('button');
          if (activeSlide) {
            activeSlide.click();
          }
        }

      })
    })

    document.querySelector('.button-product__ugc-close').addEventListener('click', function () {
      document.querySelector('.block-product__ugc').classList.toggle('hidden');
      document.body.classList.remove('product-modal__open');
      [...document.querySelector('.block-product__ugc').querySelectorAll('video')].map( video => video.pause());
      document.querySelector('.block-product__ugc').querySelectorAll('video').forEach( video => video.currentTime = 0);
    })

    document.querySelector('.button-product__ugc-sound').addEventListener('click', function () {
      const activeSlide = swiper.slides[swiper.activeIndex];
      const activeVideo = activeSlide.querySelector('video');
      activeVideo.muted = !activeVideo.muted;
      this.classList.toggle('is-muted', activeVideo.muted);
    });
  }
}
customElements.define('product-image-carousel', ProductImageCarousel);

